/**
 * Org Structure API — departments, tree, myDepartments, CRUD, seed.
 */

import { apiFetch } from './core'

export const org = {
    list: () => apiFetch('/org/departments'),
    tree: () => apiFetch('/org/tree'),
    get: (id) => apiFetch(`/org/departments/${id}`),
    myDepartments: () => apiFetch('/org/my-departments'),
    create: (data) => apiFetch('/org/departments', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    }),
    update: (id, data) => apiFetch(`/org/departments/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    }),
    delete: (id) => apiFetch(`/org/departments/${id}`, { method: 'DELETE' }),
    seed: () => apiFetch('/org/seed', { method: 'POST' }),
    rebuildHierarchy: () => apiFetch('/org/rebuild-hierarchy', { method: 'POST' }),
    assignManager: (empId, managerId) => apiFetch(`/org/employees/${empId}/manager`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ manager_id: managerId || null }),
    }),
}

// Конструктор оргсхемы (#6739): структурные правки за флагом `org_builder_v2`.
const postJson = (path) => (body) => apiFetch(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
})
export const orgBuilder = {
    reparent: postJson('/org/builder/reparent'),
    remove: postJson('/org/builder/delete'),
    restore: postJson('/org/builder/restore'),
}

// Справочник должностей организации (иерархия + отделы).
// GET возвращает [{id, title, parent_position_id, department_id, is_active}].
export const positionCatalog = {
    list: (departmentId = null) => apiFetch(
        departmentId ? `/org/position-catalog?department_id=${departmentId}` : '/org/position-catalog'
    ),
    create: (data) => apiFetch('/org/position-catalog', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    }),
}
